<template>
  <div v-loading="loading">
    <pt-page-title :title="`${title}委托单`">
      <el-button v-if="!isEdit" type="primary" plain slot="on-right" :class="$style['created-button']" @click="goLotNew">上传Excel模板创建</el-button>
    </pt-page-title>
    <pt-lab-order-form class="pt-lab-order-form__withData" ref="form" :value="currentForm" :signatureMsg="signatureInfo" :isEdit="isEdit" :recollect="recollect"></pt-lab-order-form>

  </div>
</template>

<script>
import {
  getReportSignature
} from '@/utils/formUtils'
import PtLabOrderFrom from './index'
// import { handleWorkFlow } from './form-required-option'
export default {
  name: 'pt-lab-order-form__withData',
  components: {
    'pt-lab-order-form': PtLabOrderFrom
  },
  computed: {
    form () {
      return this.$refs.form
    },
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    },
    // disabled () {
    //   return this.isEdit && this.currentForm.nextOrderAction !== 'LAB_SAMPLES_RECEIVED'
    // },
    recollect () {
      return this.$route.query.recollect === 'true'
    },
    title () {
      if (this.recollect) {
        return '创建重采'
      }
      return this.isEdit ? '编辑' : '创建'
    }
  },
  data () {
    return {
      loading: false,
      currentForm: {},
      signatureInfo: {},
      workflow: ''
    }
  },
  methods: {
    goDelete () {
      // 如果有样品不允许删除
      this.$message.error('当前委托单含有样品，无法删除')
      this.$confirm(`是否确认删除该委托单，删除后将不可恢复?`, '确认删除委托单', {
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        let data = {
          orderIds: this.selectData.map(e => e.id),
          result: true
        }
        this.$store.dispatch('handleSettle', data).then(res => {
          this.$message.success('删除成功')
          this.$router.push('/trust-deed-list')
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        })
      })
    },
    changeData (val) {
      if (val) {
        val.reportSignature = val.reportSignature || val.re ? '有' : '无'
        if (val.signatures[0]) {
          val.reportSignatureOne = getReportSignature(val.signatures[0].signature, val.signatures[0].name)
        }
        if (val.signatures[1]) {
          val.reportSignatureTwo = getReportSignature(val.signatures[1].signature, val.signatures[1].name)
        }
        if (val.signatures[2]) {
          val.reportSignatureThree = getReportSignature(val.signatures[2].signature, val.signatures[2].name)
        }
        return val
      }
    },
    goLotNew () {
      this.$router.push('/business-order-lot-new')
    },
    changeToForm (data) {
      let res = { ...data }
      // res.examBasisList = data.examBasisList.map(e => {
      //   return {
      //     value: e
      //   }
      // })
      res.preOrderSummaryList = data?.preOrderSummaryList?.map(e => {
        return {
          ...e,
          disabled: true
        }
      }) || []
      res.orderList = data.orderList?.map(e => {
        return {
          ...e,
          disabledEditProduct:true,
          disabled: true
        }
      }) || []
      // res.attachments = data.attachments?.filter(e => e.type === 'LITERATURE') || []
      return res
    },
    load (id) {
      this.loading = true
      this.$store.dispatch('getBill', id).then((data) => {
        this.loading = false
        this.currentForm = this.changeToForm(data)
      }).catch((error) => {
        this.loading = false
        this.$message.error(error || '获取订单信息失败！')
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.load(this.$route.params.id)
    }
  }
}
</script>
<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.created-button{
  margin-left: 40PX;
}
</style>
